// extracted by mini-css-extract-plugin
export var primitiveLabel = "_t8-0";